import { InputAdornment, TextField } from '@mui/material';
import './StandardTextfield.css';

function StandardTextfield({ label, type, name, value, setValue, spreadValue, variant, helperText, maxLength, prefix, disabled }) {

    const onChangeUsingName = (e) => setValue({ ...spreadValue, [e.target.name]: e.target.value })

    return (
        <TextField
            className='standardTextfield_container'
            label={label}
            type={type || 'text'}
            name={name || ''}
            helperText={helperText || ''}
            value={value}
            onChange={(e) => name ? onChangeUsingName(e) : setValue(e.target.value)}
            variant={variant || "standard"}
            fullWidth
            disabled={disabled || false}
            inputProps={{
                maxLength: maxLength || 200
            }}
            InputProps={{
                startAdornment: prefix ? <InputAdornment position="start">{prefix}</InputAdornment> : null,
            }}
        />
    )
}

export default StandardTextfield